import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({

  mainHeading: {
    padding: '0.2em 3.5em 0.3em',
    fontWeight: '700',
    fontSize: '2.5em',
    color: '#727272',
    [theme.breakpoints.down('sm')]: {
      padding: '1.5em 1.2em 0 2em',
      fontSize: '2em',
      fontFamily: 'Montserrat',
    },
  },

  mainRoot: {
    width: '100%',
    backgroundColor: '#ccc',
    backgroundPosition: "bottom left",
    backgroundRepeat: "no-repeat",
    backgroundSize: 'contain',
  },

  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '2.4em 1.6em 9em',
    fontFamily: 'Montserrat',
    width: '100%',
    maxWidth: '122em',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: '2.4em 1.6em 5em',
    },
  },

  mainContainer: {
    background: 'rgb(255, 255, 255)',
    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 14px 7px, rgba(0, 0, 0, 0.2) 0px 1px 3px 0px',
    position: 'relative',
    borderRadius: '12px'
  },

  pageHeading: {
    color: '#1A4664',
    fontFamily: 'Montserrat',
    fontSize: '22px',
    fontWeight: '700',
    letterSpacing: '0.63px',
    lineHeight: '29px',
    marginBottom: 25,
    marginTop: 24
  },

  flexBox: {
    display: 'flex',
    alignItems: 'center'
  },

  subTitle: {
    color: '#363636',
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontWeight: '600',
    letterSpacing: '0.47px',
    lineHeight: '22px',
    paddingBottom: 10,
    paddingTop: 14
  },

  seondaryColor: {
    color: theme.palette.secondary.contrastText,
    marginLeft: '17px',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '600',
    letterSpacing: '0.5px',
    lineHeight: '20px',
  },

  topFormText: {
    margin: '20px 0'
  },

  bobyText: {
    color: '#535D6D',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '500',
    letterSpacing: '0.36px',
    lineHeight: '19px',
  },

  rightMenuContainer: {
    display: 'flex',
    textAlign: 'right',
    position: 'absolute',
    top: '20px',
    right: '35px',
    alignItems: 'center'
  },

  formContainer: {
    padding: '20px',
    [theme.breakpoints.down('sm')]: {
      padding: '40px 10px 0 10px',
    },
    '& .MuiFormLabel-root.MuiInputLabel-outlined': {
      color: '#535D6D',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: '500',
      letterSpacing: '0.36px',
      lineHeight: '19px',
      background: '#fff',
      paddingRight: '5px'
    },
    '& .MuiFormLabel-root.MuiInputLabel-outlined.Mui-focused': {
      color: theme.palette.primary.main,
    },
  },

  textField: {
    color: "#585757",
    fontFamily: "Montserrat",
    fontSize: " 16px",
    fontWeight: '500'
  },

  textInput: {
    fontWeight: '600'
  },

  formText: {
    color: '#535D6D',
    fontFamily: 'Montserrat',
    fontSize: '18px',
    fontWeight: '600',
    letterSpacing: '0.4px',
    lineHeight: '22px'
  },

  resetButton: {
    fontFamily: 'Montserrat',
    letterSpacing: '0.36px',
    fontWeight: '600',
    marginRight: '25px',
    width: '180px',
    height: '40px',
    border: "2px solid",
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
    borderColor: theme.palette.primary.main,
    '&:hover': {
      border: "2px solid",
      borderColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: '28px',
      marginRight: 0,
      marginTop: 30
    },
  },
  addAccButton: {
    width: '180px',
    fontFamily: 'Montserrat',
    fontWeight: '600',
    textTransform: 'uppercase',
    height: '40px',
  },
  buttonContainer: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
    },
  },

  errorMsg: {
    fontSize: '1.4em',
    fontWeight: '600',
    marginBottom: 10,
    marginTop: 5,
    fontFamily: 'Montserrat',
    color: "red",
  },

  validationErr: {
    fontSize: '12px',
    fontWeight: '500',
    top: 1,
    left: 0,
    fontFamily: 'Montserrat',
    color: "red",
    margin: '2px 0'
  },

  loaderRoot: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  rowMargin: {
    marginBottom: 40,
  },

  infoBox: {
    borderRadius: '6px',
    backgroundColor: theme.palette.secondary.main,
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
    padding: '15px 60px',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      padding: '7px 20px',
    },
  },

  refreshButton: {
    backgroundColor: 'rgb(37, 171, 199)',
    color: 'rgb(255,255,255)',
    cursor: 'pointer'
  },
  volumeButton: {
    backgroundColor: 'rgb(37, 171, 199)',
    color: 'rgb(255,255,255)',
    cursor: 'pointer'
  },
  captchaarea: {
     border: '2px solid #D9D9D9',
     borderRadius: '6px'
  },
  captchasize: {
    fontSize: '38px',
    padding: '2px',
    margin: 0,
    fontFamily: 'cursive',
    fontWeight: '600'
  },
  buttonarea: {
    textAlign: 'right',
    paddingTop: '3px'
  },
  error: {
    fontSize: '1.2em',
    fontWeight: 'bold',
    textAlign: 'left',
    marginTop: 5,
    fontFamily: 'Montserrat',
    color: "red",
  },

  errorIconStyle: {
    fill: '#B00020', fontSize: '40px'
  },
  warningBox: {
    display: 'flex'
  },
  disappeared: {
    color: '#4D4D4D',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: '500',
    marginLeft: 10
  },
  imageContainer: {
    display: "flex"
  },
  infoIcon: {
    paddingRight: "10px",
    fontSize: '30px',
    color: "#E02020"
  },
  paragraph: {
    color: "#E02020",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: "500",
    paddingTop: 5
 },
 clickLink: {
  color: '#007FFF',
  fontFamily: 'Montserrat',
  fontSize: '16px',
  fontStyle: 'normal',
  cursor:'pointer',
  fontWeight: '700',
  lineHeight: '16px',
  textDecorationLine: 'underline'
 },
 loanNo: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    paddingTop: 4
  },
  account: {
    color: "#4D4D4D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "400",
    paddingTop: 4
  },
   marginFixed: {
    marginTop: 12
  },
    activeRadioLabel: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: "bold",
  },

  radioLabel: {
    color: "rgba(0,0,0,0.74)",
    fontFamily: "Montserrat",
    fontSize: " 16px",
    fontWeight: "500",
  },
  borrowerInfo: {
    color: '#363636',
    fontFamily: 'Montserrat',
    fontSize: '22px',
    fontWeight: '600',
    letterSpacing: '0.47px',
    lineHeight: '22px'
  },
   radioLabel: {
    color: "rgba(0,0,0,0.74)",
    fontFamily: "Montserrat",
    fontSize: " 16px",
    fontWeight: "500",
  },
  heading: {
    color: '#363636',
    fontFamily: 'Montserrat',
    fontSize: '18px',
    fontWeight: '600',
    letterSpacing: '0.47px',
    lineHeight: '22px',
    margin: '20px 0 20px 0'
  },
  information: {
    color: '#363636',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '600',
    letterSpacing: '0.47px',
    lineHeight: '22px',
    margin: '20px 0 20px 0'
  },
  info: {
    color: '#4D4D4D',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '500',
    letterSpacing: '0.47px',
    lineHeight: '22px',
    margin: '20px 0 4px 0'
  },
  view : {
    color: "#0071FF",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: "700",
    textDecoration: 'underline',
    cursor: 'pointer'
  },
   textAreaValidation: {
      color: '#202020',
      float: 'right'
   },
   textArea: {
      color: "#202020",
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontWeight: 500,
      width: '100%',
      padding: "10px",
      height: '56px',
      border: 'none',
      outline: 'none',
      borderRadius: '4px',
      border: '1px solid #9E9E9E',
      "&::placeholder": {    
        fontSize: '14px', 
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '1rem',
        fontFamily: 'Montserrat',
        fontWeight: 400,
        lineHeight: 1
       }
    },
    desc: {
      color: "rgba(0,0,0,0.74)",
      fontFamily: "Montserrat",
      fontSize: " 16px",
      fontWeight: "500"
    },
     line: {
      margin: '12px 0px 20px 0px',
      border: '1px solid #f7b15c47'
    },
    welcome: {
      color: "#4D4D4D",
      fontFamily: "Montserrat",
      fontSize: 22,
      fontWeight: '700'
    },
    imageContainer: {
      display: "flex", 
      paddingTop: 10
    },
    infoIcon: {
      paddingRight: "10px",
      fontSize: '30px',
      color: "#E02020"
    },
    note: {
      color: "#4D4D4D",
      fontFamily: "Montserrat",
      fontSize: 12,
      fontWeight: "700",
      paddingTop: 5
    },
    cancellation: {
      color: "#4D4D4D",
      fontFamily: "Montserrat",
      fontSize: 12,
      fontWeight: "500",
      paddingTop: 5
    },
    icon: {
      paddingRight: 8,
      paddingBottom: 2,
      fontSize: 26,
      color: "#007FFF"
    },
    loaderRoot: {
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
     statement: {
      color: '#4D4D4D',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: '500',
      letterSpacing: '0.47px',
      lineHeight: '18px',
      margin: '10px 0 4px 0'
    },

}));